import { Box, useTheme } from '@mui/material';
import { LoadingSkeleton } from '../../common/components';

// Componentes separados
import { TableTitleBox } from '../../common/components';

import CouponsFilters from './components/CouponsFilters';
import CouponsDataTable from './components/CouponsDataTable';
import CouponsPagination from './components/CouponsPagination';
import EditCouponDialog from './components/EditCouponDialog';
import EditAdvanceDialog from './components/EditAdvanceDialog';

// Hook personalizado
import { useCouponsTable } from './hooks/useCouponsTable';

/**
 * Componente principal de la tabla de cupones
 * Refactorizado para mejor mantenimiento y responsividad
 */
const CouponsTable = () => {
  const theme = useTheme();

  // Hook personalizado que maneja toda la lógica
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filter,
    plans,
    groups,
    selectedData,
    coeficienteActual,
    open,
    openAdelantoDialog,
    handleDownload,
    handleFilter,
    handleOpenDialog,
    handleClose,
    handleSave,
    handleDeleteCoupon,
    handleRegenerateCouponQrs,
    regeneratingId,
    handlePageChange,
    handleRowsPerPageChange,
    dispatch,
    setEditCouponField,
    calculateInterest,
  } = useCouponsTable();

  return (
    <>
      <Box>
        <TableTitleBox title="Habitat 99 | Cupones | Ver Cupones" />

        <CouponsFilters filter={filter} handleFilter={handleFilter} plans={plans} groups={groups} />

        <CouponsDataTable
          data={data}
          isLoading={isLoading}
          onEdit={handleOpenDialog}
          onDelete={handleDeleteCoupon}
          onDownload={handleDownload}
          onRegenerate={handleRegenerateCouponQrs}
          regeneratingId={regeneratingId}
          LoadingComponent={LoadingSkeleton}
        />

        <CouponsPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
          theme={theme}
        />
      </Box>

      <EditCouponDialog
        open={open}
        onClose={handleClose}
        selectedData={selectedData}
        calculateInterest={calculateInterest}
      />

      <EditAdvanceDialog
        open={openAdelantoDialog}
        onClose={handleClose}
        onSave={handleSave}
        selectedData={selectedData}
        coeficienteActual={coeficienteActual}
        dispatch={dispatch}
        setEditCouponField={setEditCouponField}
      />
    </>
  );
};

export default CouponsTable;
